// 単一キャラクター用のクラス
export class SingleDogAnimation {
  static LEFT_EYE_WHITE = { cx: 68.8603, cy: 87.5951, rx: 7.13376, ry: 7.07071 };
  static LEFT_EYE_BLACK = { cx: 68.8592, cy: 87.5947, rx: 2.25277, ry: 2.23286 };
  static RIGHT_EYE_WHITE = { cx: 97.2021, cy: 87.5951, rx: 7.13376, ry: 7.07071 };
  static RIGHT_EYE_BLACK = { cx: 97.202, cy: 87.5947, rx: 2.25277, ry: 2.23286 };
  static PUPIL_RADIUS = { rx: 2.25277, ry: 2.23286 };

  svg: SVGElement;
  characterId: number;
  isActive: boolean;
  leftEyeBlack: SVGElement | null;
  rightEyeBlack: SVGElement | null;
  tongueElement: SVGElement | null;
  isHovered: boolean = false;

  constructor(svgElement: SVGElement, characterId: number) {
    this.svg = svgElement;
    this.characterId = characterId;
    this.isActive = true;

    // 目の要素を取得（このキャラクター専用）
    this.leftEyeBlack = this.svg.querySelector(".eye-left-black");
    this.rightEyeBlack = this.svg.querySelector(".eye-right-black");
    this.tongueElement = this.svg.querySelector(".tongue");

    // ホバーイベントを設定
    this.initHoverEvents();
  }

  updateEyes(mouseX: number, mouseY: number) {
    if (!this.isActive) return;

    const svgRect = this.svg.getBoundingClientRect();
    const svgX = (mouseX - svgRect.left) * (160 / svgRect.width);
    const svgY = (mouseY - svgRect.top) * (200 / svgRect.height);

    const leftPos = this.calculatePupilPosition(
      svgX,
      svgY,
      SingleDogAnimation.LEFT_EYE_WHITE,
      SingleDogAnimation.PUPIL_RADIUS
    );
    const rightPos = this.calculatePupilPosition(
      svgX,
      svgY,
      SingleDogAnimation.RIGHT_EYE_WHITE,
      SingleDogAnimation.PUPIL_RADIUS
    );

    this.leftEyeBlack?.setAttribute("cx", leftPos.x.toString());
    this.leftEyeBlack?.setAttribute("cy", leftPos.y.toString());
    this.rightEyeBlack?.setAttribute("cx", rightPos.x.toString());
    this.rightEyeBlack?.setAttribute("cy", rightPos.y.toString());
  }

  calculatePupilPosition(
    mouseX: number,
    mouseY: number,
    eyeWhite: { cx: number; cy: number; rx: number; ry: number },
    pupilSize: { rx: number; ry: number }
  ) {
    // 目の中心からマウス位置への方向ベクトル
    const dx = mouseX - eyeWhite.cx;
    const dy = mouseY - eyeWhite.cy;

    // 距離を計算
    const distance = Math.sqrt(dx * dx + dy * dy);

    // 瞳が白い部分からはみ出さないように制限する範囲を計算
    const maxMoveX = eyeWhite.rx - pupilSize.rx;
    const maxMoveY = eyeWhite.ry - pupilSize.ry;

    // 移動できる最大距離（楕円形の制約）
    const normalizedDistance = Math.sqrt(
      (dx * dx) / (maxMoveX * maxMoveX) + (dy * dy) / (maxMoveY * maxMoveY)
    );

    let newX, newY;

    if (normalizedDistance <= 1) {
      // マウスが制限範囲内にある場合、そのまま追従
      newX = eyeWhite.cx + dx;
      newY = eyeWhite.cy + dy;
    } else {
      // マウスが制限範囲外にある場合、境界に制限
      const scale = 1 / normalizedDistance;
      newX = eyeWhite.cx + dx * scale;
      newY = eyeWhite.cy + dy * scale;
    }

    return { x: newX, y: newY };
  }

  showTongue(): void {
    if (this.tongueElement) {
      this.tongueElement.style.transform = "translateY(0px)";
    }
  }

  hideTongue(): void {
    if (this.tongueElement) {
      this.tongueElement.style.transform = "translateY(-10%)";
    }
  }

  initHoverEvents(): void {
    this.svg.addEventListener("mouseenter", () => {
      this.isHovered = true;
      this.showTongue();
    });

    this.svg.addEventListener("mouseleave", () => {
      this.isHovered = false;
      this.hideTongue();
    });
  }
}

// 複数管理
export class MultipleDogAnimation {
  trackers: Map<number, SingleDogAnimation>;
  isTracking: boolean;

  constructor() {
    this.trackers = new Map();
    this.isTracking = true;
    this.init();
  }

  init() {
    document.addEventListener("mousemove", (e) => this.handleGlobalMouseMove(e));
  }

  handleGlobalMouseMove(event: MouseEvent) {
    if (!this.isTracking) return;

    // すべてのキャラクターの目を更新
    this.trackers.forEach((tracker) => {
      tracker.updateEyes(event.clientX, event.clientY);
    });
  }
}

// 最初のアニメーション
export class FirstAnimation {
  constructor() {
    this.init();
  }

  init() {
    const dogs = document.querySelectorAll(".dog .inu-main");
    dogs.forEach((dog: Element) => {
      dog.classList.add("animation-start");
    });
  }
}
